import {
	apiAppSettingsTagDelete,
	apiAppSettingsTagGet,
	apiAppSettingsTagUpsert
} from '#lib/types/generated/index.js';
import { get, writable } from 'svelte/store';

export const tagStore = writable<string[]>([]);

export function loadTags(): Promise<string[]> {
	return apiAppSettingsTagGet().then((res) => {
		tagStore.set(res.tags);
		return res.tags;
	});
}

export async function deleteTag(tag: string): Promise<void> {
	const previous = get(tagStore);
	tagStore.set(previous.filter((t) => t !== tag));

	try {
		await apiAppSettingsTagDelete(tag);
	} catch (error: unknown) {
		tagStore.set(previous);
		throw error;
	}
}

export async function createTag(label: string): Promise<string[]> {
	const res = await apiAppSettingsTagUpsert({ label });
	tagStore.set(res.tags);
	return res.tags;
}
